import { render, staticRenderFns } from "./TaxInvoiceManage.vue?vue&type=template&id=453ef9cc&scoped=true&"
import script from "./TaxInvoiceManage.vue?vue&type=script&lang=js&"
export * from "./TaxInvoiceManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453ef9cc",
  null
  
)

export default component.exports